import { DBDef_ProviderChatInteraction } from '@app/advisor-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
import { ModuleFE_BaseAdvisorRuntime } from '../../../modules/ModuleFE_BaseAdvisorRuntime.js';
import { ModuleFE_AdvisorSession } from '../../advisor-session/index.js';
export const dispatch_onProviderChatInteractionsUpdated = new ThunderDispatcherV3('__onProviderChatInteractionsUpdated');
class ModuleFE_ProviderChatInteraction_Class extends ModuleFE_BaseAdvisorRuntime {
    constructor() {
        super(DBDef_ProviderChatInteraction, dispatch_onProviderChatInteractionsUpdated);
    }
    init() {
        super.init();
        this.setCacheFilter(ModuleFE_AdvisorSession.providerAndEncounterFilter);
    }
}
export const ModuleFE_ProviderChatInteraction = new ModuleFE_ProviderChatInteraction_Class();
//# sourceMappingURL=ModuleFE_ProviderChatInteraction.js.map